import { Table as CommonTable } from '@aslanpay/portal-common-lib';

import BulkActions from './BulkActions';

import type { TableProps } from './Table.types';

function Table<TData extends object>(props: TableProps<TData>) {
  const {
    bulkActions,
    bulkActionsType,
    total,
    onSelectAll,
    isSelectingAll,
    selectedCount,
    ...rest
  } = props;

  return (
    <CommonTable {...rest} total={total}>
      {(table) =>
        bulkActions &&
        bulkActionsType &&
        table.getSelectedRowModel().flatRows.length > 0 && (
          <BulkActions
            selectedRows={table.getSelectedRowModel().flatRows}
            actions={bulkActions}
            type={bulkActionsType}
            totalCount={total}
            onSelectAll={onSelectAll}
            isSelectingAll={isSelectingAll}
            selectedCount={selectedCount}
          />
        )
      }
    </CommonTable>
  );
}

export default Table;
